import axios from './config/config-viva'
const defaultRoute = 'usuarios/'
export default{
    list:(type)=>{
        return axios.get(`${defaultRoute}?type=${type}`)
    },
    create:(user)=>{
        return axios.post(defaultRoute,user)
    },
    update:(id, user)=>{
        return axios.put(defaultRoute+id, user)
    },
    remove:(id)=>{
        return axios.delete(defaultRoute+id)
    },
    async usedValue(field, value) {
        if(value == ''){
            return false
        }
        return (await axios.get(`${defaultRoute}${field}/${value}`)).data.data
    }
} 